import * as React from "react";
import styled, { css } from "styled-components";
import { Theme } from "../../../theme";
import { useTheme } from "@material-ui/styles";
import { useMediaQuery } from "@material-ui/core";

const StyledSection = styled.section`
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
  /* border: 1px solid #aaa; */
  border-radius: 5px;
  padding-left: 24px;
  padding-right: 8px;

  .nameHeader {
    text-align: left;
    width: 224px;
    color: #111;
    font-weight: 500;
    margin-top: -12px;
    margin-bottom: -12px;
  }
  .description {
    max-width: 300px;
    color: #111;
    font-weight: 500;
    margin-top: -12px;
    margin-bottom: -12px;
  }

  .spacer {
    flex: 1;
  }

  .measurementsHeaders {
    width: 240px;
    display: flex;
    margin-top: -12px;
    margin-bottom: -12px;
    padding-right: -12px;
    div.header {
      text-align: right;
      flex: 1;
      /* border: 1px solid red; */
    }

    p.headerText {
      color: #111;
      font-weight: 500;
    }
  }

  ${({ theme }: { theme: Theme }) => {
    return css``;
  }};
`;

export interface CameraSummaryHeadingsProps {}

const CameraSummaryHeadings: React.FC<CameraSummaryHeadingsProps> = props => {
  const theme: Theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  const headers = ["Density", "Flow", "Mood"];

  return (
    <>
      <StyledSection theme={theme}>
        <div className="nameHeader">
          <p>Deployment</p>
        </div>
        {mdUp && (
          <div className="description">
            <p>Description</p>
          </div>
        )}
        <div className="spacer"></div>
        <div className="measurementsHeaders">
          {headers.map(h => (
            <div className="header">
              <p className="headerText">{h}</p>
            </div>
          ))}
        </div>
      </StyledSection>
    </>
  );
};

export default CameraSummaryHeadings;
